import { PropsWithChildren, ReactNode } from 'react'
import { LucideIcon } from 'lucide-react'

interface Props {
  icon: LucideIcon
  title: string
  description?: ReactNode
}

const StepLayout = ({
  icon: Icon,
  title,
  description,
  children,
}: PropsWithChildren<Props>) => {
  return (
    <div>
      <div className='mb-6 flex flex-col gap-3'>
        <div className='flex items-center justify-between gap-4'>
          <div className='flex items-center gap-4'>
            <span className='flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary'>
              <Icon className='h-5 w-5' />
            </span>
            <h2 className='text-2xl font-semibold mb-0'>{title}</h2>
          </div>
        </div>
        {description ? <p className='text-foreground'>{description}</p> : null}
      </div>

      {children}
    </div>
  )
}

export default StepLayout
